module.exports = __webpack_public_path__ + "static/logo-dark-a627f2ba1625cbc80010154fa63bac3d.png";